import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ManagedModalDirective } from "../managed-modal/managed-modal.directive";

@Component({
    selector: "app-alert-dialog",
    templateUrl: "./alert-dialog.component.html",
    standalone: true,
    imports: [ManagedModalDirective],
})
export class AlertDialogComponent {
  @Input() dialogTitle: string;
  @Input() dialogSubtitle: string;
  @Input() visible: boolean;
  @Input() isError: boolean;
  @Output() onClose = new EventEmitter<boolean>();

  constructor() {}

  onClick() {
    this.onClose.emit(true);
  }
}
